export var SnapshotCoverageAvailability;
(function (SnapshotCoverageAvailability) {
    SnapshotCoverageAvailability["SNAPSHOT_COVERAGE_AVAILABILITY_AVAILABLE"] = "AVAILABLE";
    SnapshotCoverageAvailability["SNAPSHOT_COVERAGE_AVAILABILITY_UNAVAILABLE_NOT_FULL_SCAN"] = "UNAVAILABLE_NOT_FULL_SCAN";
    SnapshotCoverageAvailability["SNAPSHOT_COVERAGE_AVAILABILITY_UNSUPPORTED_RESOURCE_TYPE"] = "UNSUPPORTED_RESOURCE_TYPE";
})(SnapshotCoverageAvailability || (SnapshotCoverageAvailability = {}));
